<template>
    <div class="card bg-dark text-white image-card">
        <img :src="img_url" class="card-img" :alt="img_alt">
        <div class="card-img-overlay" v-if="typeof $slots['text'] !== 'undefined'">
            <h5 class="card-title">
                <slot name="title"></slot>
            </h5>
            <p class="card-text">
                <slot name="text"></slot>
            </p>
        </div>
    </div>
</template>

<script>

export default {
    components: {},

    props: {
        img_url: {},
        img_alt: {},
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">
    .image-card {
        .card-img-overlay {
            background-color: rgba(0,0,0,0.5);
        }
    }
</style>
